module.exports = __webpack_public_path__ + "img/icon_add@3x.a3c9d143.png";